export default {
  ALWAYS_SHOW_LOADING: false
};



// WEBPACK FOOTER //
// ./src/config.js